const TestimonialsSchema = {
  title: 'Testimonials',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'title', 
        'slides'
      ],
    },
  ],

  properties: {
    title: {
      title: 'Title',
      description: 'Adds a title above the slides',
      type: 'string',
    },

    slides: {
      title: 'Testimonial Slides',
      widget: 'object_list',
      schema: {
        title: 'Slide',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: ['image', 'name', 'role', 'quote', 'socials'],
          },
        ],
        properties: {
          image: {
            title: 'Thumbnail Image',
            type: 'string',
            widget: 'image',
          },
          name: {
            title: 'Name',
            type: 'string',
          },
          role: {
            title: 'Role',
            type: 'string',
          },
          quote: {
            title: 'Quote',
            type: 'string',
            widget: 'textarea',
          },
          socials: {
            title: 'Social Networks',
            widget: 'object_list',
            schema: {
              title: 'Item',
              fieldsets: [
                {
                  id: 'default',
                  title: 'Default',
                  fields: ['social', 'link'],
                },
              ],
              properties: {
                social: {
                  title: 'Social network',
                  type: 'string',
                  choices: [
                    ['in', 'LinkedIn'],
                    ['p', 'Pinterest'],
                    ['g', 'Google Plus'],
                  ],
                  default: 'in'
                },
                link: {
                  title: 'Link',
                  type: 'string',
                },
              },
              required: [],
            },
          },
        },
        required: [],
      },
    },
  },

  required: ['items'],
};

export default TestimonialsSchema;